module.exports = __webpack_public_path__ + "media/Award_Wining_Culture.7563d9eb.mp4";